import api from '../../services/api';
import { Creators } from '../ducks/github_api';
import { call, put } from 'redux-saga/effects';
import { actions as toastrActions } from 'react-redux-toastr';
import { captureSentryException } from '../../utils';

export function* getGithubApi({ filter }) {
  try {
    let response; 

    yield put(Creators.githubApiRequest());
    response = yield call(api.post, 'github-api', filter);

    yield put(Creators.githubApiSuccess(response.data));
  } catch (err) {
    yield captureSentryException(err, filter);
    yield put(Creators.githubApiError({ err }));
    yield put(toastrActions.add({
      type: 'error',
      title: 'Erro',
      message: 'Falha ao buscar versões dos apps'
    }));
  }
} 